var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrimaryfill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C4.4775 0 0 4.4775 0 10C0 15.5238 4.4775 20 10 20C15.5225 20 20 15.5238 20 10C20 4.4775 15.5225 0 10 0ZM7.13388 5.36661C6.64573 4.87846 5.85427 4.87846 5.36612 5.36661C4.87796 5.85477 4.87796 6.64622 5.36612 7.13438L8.23223 10.0005L5.36612 12.8666C4.87796 13.3548 4.87796 14.1462 5.36612 14.6344C5.85427 15.1225 6.64573 15.1225 7.13388 14.6344L10 11.7683L12.8661 14.6344C13.3543 15.1225 14.1457 15.1225 14.6339 14.6344C15.122 14.1462 15.122 13.3548 14.6339 12.8666L11.7678 10.0005L14.6339 7.13438C15.122 6.64622 15.122 5.85477 14.6339 5.36661C14.1457 4.87846 13.3543 4.87846 12.8661 5.36661L10 8.23273L7.13388 5.36661Z",
    fill: "#DEDEDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryfill);
export default __webpack_public_path__ + "static/media/Primaryfill.987c2db17e77b34135d78995b6a5e545.svg";
export { ForwardRef as ReactComponent };